import {DEFAULT_REQUEST_TIMEOUT} from '@raison/network-facade';
import axios, {AxiosRequestConfig, RawAxiosRequestHeaders} from 'axios';
import * as config from '~/config';
import {axiosWithRefresh} from '~/root/api/client';
import {appSessionStorage} from '../persistence';

export type ApiCallOptions = AxiosRequestConfig & {token?: string | null; currency?: string};

const {SERVICE_UNAVAILABLE_MESSAGE} = config;

export const token = () => appSessionStorage.authToken.get();

const apiCall = (url: string, options = {} as ApiCallOptions, noTimeout?: boolean) => {
    const headers: RawAxiosRequestHeaders = {
        'Content-Type': 'application/json',
        // eslint-disable-next-line no-restricted-globals
        'X-Referer': location.href,
    };

    if (options?.token) {
        headers['Authorization'] = `Bearer ${options.token}`;
    }

    const customOptions = {
        url: url,
    };

    const timeout = noTimeout ? undefined : DEFAULT_REQUEST_TIMEOUT;

    return axiosWithRefresh({
        headers,
        ...options,
        ...customOptions,
        timeout,
    })
        .then(response => response?.data || {})
        .catch(error => {
            error.response = error.response || {}; // prevent js errors if no internet
            error.response.data = error.response.data || {};
            if (!navigator.onLine) {
                error.response.data.message = 'No internet connection!';
            } else if (axios.isCancel(error)) {
                console.log(error.message);
            } else if (error.response.status >= 500) {
                error.response.data.message = SERVICE_UNAVAILABLE_MESSAGE;
            }
            if (Object.keys(error.response.data).length === 0) {
                throw error;
            }
            throw error.response.data;
        });
};


export const apiPost: typeof apiCall = (url, options = {}, noTimeout) =>
    apiCall(url, {...options, method: 'post'}, noTimeout);


